import React, { useEffect, useState } from "react";
import { db, collection, onSnapshot } from "../boardData";
import { WidgetShell, EmptyState } from "./common";

function toDate(v) {
  if (!v) return null;
  if (typeof v.toDate === "function") return v.toDate();
  if (typeof v.seconds === "number") return new Date(v.seconds * 1000);
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
}

const DepartmentCalendarWidget = ({ config = {}, agency }) => {
  const [events, setEvents] = useState([]);
  const rangeDays = config.rangeDays || 14;

  useEffect(() => {
    if (!agency) return undefined;
    const unsub = onSnapshot(
      collection(db, "Agencies", agency, "calendar"),
      (snap) => {
        const now = new Date();
        const end = new Date(now.getTime() + rangeDays * 24 * 60 * 60 * 1000);
        const list = snap.docs
          .map((d) => ({ id: d.id, ...d.data() }))
          .map((e) => ({ ...e, _start: toDate(e.startDate || e.start || e.date) }))
          .filter((e) => e._start && e._start >= new Date(now.toDateString()) && e._start <= end)
          .sort((a, b) => a._start - b._start);
        setEvents(list);
      },
      (err) => console.warn("calendar load failed", err)
    );
    return () => unsub();
  }, [agency, rangeDays]);

  return (
    <WidgetShell title="Upcoming Events">
      {events.length === 0 ? (
        <EmptyState icon="📅" label="No upcoming events." />
      ) : (
        <div className="sb-cal-list">
          {events.map((e) => (
            <div className="sb-cal-item" key={e.id}>
              <div className="sb-cal-date">
                <div className="sb-cal-month">
                  {e._start.toLocaleDateString([], { month: "short" })}
                </div>
                <div className="sb-cal-day">{e._start.getDate()}</div>
              </div>
              <div className="sb-cal-info">
                <div className="sb-cal-title">{e.title || e.name || "Event"}</div>
                <div className="sb-cal-time">
                  {e._start.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
                  {e.location ? ` · ${e.location}` : ""}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </WidgetShell>
  );
};

export default DepartmentCalendarWidget;
